import React, { useContext, useEffect, useState } from "react";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import ModalHeader from "../../../../components/Modal/ModalHeader";
import { Dropdown, IconButton, Modal, TextField } from "@fluentui/react";
import ModalFooter from "../../../../components/Modal/ModalFooter";
import QCModalHeader from "../../../../components/Modal/QCModalHeader";
import QCModalFooter from "../../../../components/Modal/QCModalFooter";
import QCFailReasons from "./QCFailReasons";
import ATextField from "../../../../components/ATextField";
import { FileUploader } from "react-drag-drop-files";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import { useTranslation } from "react-i18next";
import themeContext from "../../../../context/theme/ThemeContext";

const UploadFistolugramModal = (props) => {
  const {
    setFistolugramUploadModal,
    uploadFistolugramFunc
  } = useContext(studyReportContext);
  const {getThemeColor,themeName} = useContext(themeContext);
  const [errorMessage, setErrorMessage] = useState("");
  const [toBeUploadFile, setToBeUploadFile] = useState(null);
  const { t } = useTranslation();

  const handleCancel = () => {
    setFistolugramUploadModal(false);
    setToBeUploadFile(null);
  };

  const fileTypes = ["JPEG", "jpeg", "PNG", "png", "JPG", "jpg"];

  const handleFileUploadChange = (file) => {
    setToBeUploadFile(file);
  };

  const PrimaryButtonList = [
    {
      title: t("button.close"),
      onclick: () => {
        setFistolugramUploadModal(false);
      },
    },
    {
      title: t("button.upload"),
      disable: toBeUploadFile == null ? true : false,
      onclick: () => {
        uploadFistolugramFunc(props.studyParentId,toBeUploadFile);
        setFistolugramUploadModal(false);
      },
    },
  ];

  return (
    <>
      <div
        style={{
          height: "25%",
          width: "60%",
        }}
      >
        {/* <Modal
          isOpen={true}
          titleAriaId="id"
          scrollableContentClassName={"stop-scroll-for-modal"}
        > */}
        <QCModalHeader
          heading={t("QC.upload-fistulogram")}
          handleCancel={handleCancel}
          isFistolugramHeader={true}
        />
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            backgroundColor: getThemeColor("modal-body"),
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              padding: "5px 20px",
            }}
          >
            <FileUploader
              handleChange={handleFileUploadChange}
              name="files"
              types={fileTypes}
              label={t("history-upload.drag-or-browse-files")}
              multiple={false}
              children={
                <p className="fileUploader">
                  {t("history-upload.drag-or-browse-files")}
                </p>
              }
            />
            {toBeUploadFile != null && (
              <div className="fileNames-container">
                <div 
                  className="file-name-upload-fistolugram" 
                    style={{
                      backgroundColor: themeName === "light" ? "#7B7B7B" : "",
                    }}
                  >
                  {toBeUploadFile.name}
                  <IconButton
                    iconProps={{ iconName: t("button.cancel") }}
                    ariaLabel="Remove file"
                    onClick={() => setToBeUploadFile(null)}
                    className="file-crossIcon"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <QCModalFooter PrimaryButtonList={PrimaryButtonList} />
        {/* </Modal> */}
      </div>
    </>
  );
};

export default UploadFistolugramModal;
